// extracted by mini-css-extract-plugin
export default {"timerBoard":"TimerBoard_timerBoard__46jds"};